// eslint-disable-next-line @typescript-eslint/no-unused-vars
import UIkit from 'uikit/dist/js/uikit-core';
import initHeaderScroll from './theme/headerScroll';
import initTeamSlider from './theme/teamSlider';
import initLinkSlider from './theme/linkSlider';
import initTeamSearch from './theme/teamSearch';
import initBlogSlider from './theme/blogSlider';
import initArticleSearch from './theme/articleSearch';
import initHeaderSearch from './theme/headerSearch';

initHeaderScroll();
initHeaderSearch();
initTeamSlider();
initLinkSlider();
initTeamSearch();
initBlogSlider();
initArticleSearch();